import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import './Fade.scss';

const transitionProps = {
	classNames: 'fade',
	timeout: { enter: 400, exit: 350 },
};

const TransitionRoute = props => <CSSTransition {...transitionProps} {...props} />;

const Fade = ({ location, children, customKey }) => (
	<TransitionGroup component={null}>
		<TransitionRoute key={customKey}>{children}</TransitionRoute>
	</TransitionGroup>
);

TransitionRoute.propTypes = {};

Fade.propTypes = {
	location: PropTypes.shape({}),
	customKey: PropTypes.string,
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

Fade.defaultProps = {
	location: null,
	customKey: null,
	children: null,
};

export default withRouter(Fade);
